export default __webpack_public_path__ + "static/media/ACF-logo-disabled.29ca8c66.svg";